var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"igdb-credit",attrs:{"href":_vm.href,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/img/igdb-logo.svg"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('igdbCredit.poweredByIgdb')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40573640","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IgdbCredit.vue
// module id = null
// module chunks = 